<div #filtersWrapper class="avia-filters-wrapper" [style.height.px]="isFiltersFixed ? filtersHeight : null">
    <div #filtersBar class="avia-filters" [class.avia-filters_fixed]="isFiltersFixed">
        @if (isShowSkeletons) {
            <app-filter-pills-skeleton/>
        }

        @if (filtersLoadFailed && appliedFilters.length) {
            <button type="button" class="btn btn-blue" (click)="resetUnavailableFilters()">{{ resetFiltersLabel }}</button>
        }
        @if (hasFilters) {
            <app-filter-pills [filters]="filtersWithSort"
                              [appliedFilters]="appliedFilters"
                              (applyFilters)="onApplyFilter($event)"
                              (applyFilterGroup)="onApplyFilterGroup($event)"
                              (resetFilter)="onResetFilter($event)"
                              (resetFilterGroup)="onResetFilterGroup($event)"/>
        }
    </div>
</div>
